export const navLinks = [
  { label: "Nos placements", href: "#placements" },
  { label: "Le cabinet", href: "#engagements" },
  { label: "Méthode", href: "#methode" },
  { label: "Équipe", href: "#equipe" },
  { label: "Contact", href: "#contact" },
];

export const regulators = [
  "AMF",
  "ACPR",
  "ORIAS n°13009531",
  "ANACOFI-CIF",
  "MMA-Covéa Risks",
];

export const commitments = [
  {
    title: "Une sélection des meilleurs placements du marché",
    text: "Nous comparons en continu les offres des assureurs, sociétés de gestion et plateformes pour ne retenir que les plus solides.",
  },
  {
    title: "Un interlocuteur dédié à l’écoute de vos besoins",
    text: "Un seul conseiller vous suit d’année en année et connaît votre situation, vos projets et vos contraintes.",
  },
  {
    title: "Des partenaires solides pour sécuriser votre épargne",
    text: "Vos avoirs sont logés chez des établissements de premier plan, contrôlés par l’ACPR et l’AMF.",
  },
];

export const solutions = [
  {
    name: "Assurance-vie",
    text: "Contrats multisupports à frais réduits, fonds euros et unités de compte sélectionnées.",
    horizon: "8 ans +",
  },
  {
    name: "Plan d’Épargne Retraite",
    text: "Préparer sa retraite tout en réduisant son impôt sur le revenu dès aujourd’hui.",
    horizon: "Long terme",
  },
  {
    name: "SCPI & immobilier",
    text: "Des revenus réguliers issus de l’immobilier professionnel, sans gestion locative.",
    horizon: "10 ans +",
  },
  {
    name: "Private equity",
    text: "Accéder au capital de PME non cotées, avec un accompagnement sur la fiscalité.",
    horizon: "7 ans +",
  },
  {
    name: "Produits structurés",
    text: "Des scénarios de gain définis à l’avance, conçus avec les salles de marché.",
    horizon: "3 à 10 ans",
  },
];

export const clientSpaceFeatures = [
  {
    title: "Votre patrimoine en un coup d’œil",
    text: "Tous vos contrats consolidés, valorisés et mis à jour quotidiennement.",
  },
  {
    title: "Documents et signature en ligne",
    text: "Relevés, avenants et rapports annuels centralisés et signables à distance.",
  },
  {
    title: "Échangez avec votre conseiller",
    text: "Messagerie sécurisée et prise de rendez-vous directement depuis votre espace.",
  },
];

export const dashboardContracts = [
  { name: "Assurance-vie Linxea Spirit 2", value: "142 380 €", perf: "+7,2 %" },
  { name: "PER Individuel", value: "58 920 €", perf: "+5,8 %" },
  { name: "SCPI Rendement", value: "47 260 €", perf: "+4,6 %" },
];

export const dashboardAllocation = [
  { label: "Fonds euros", share: 38, color: "#FFFFFF" },
  { label: "Actions", share: 32, color: "#3DD68C" },
  { label: "Immobilier", share: 19, color: "#8A8A8F" },
  { label: "Obligations", share: 11, color: "#4A4A4F" },
];

export const methodSteps = [
  {
    title: "Audit patrimonial",
    text: "Nous analysons votre situation familiale, fiscale et financière ainsi que vos objectifs, gratuitement et sans engagement.",
  },
  {
    title: "Stratégie sur-mesure",
    text: "Nous vous présentons une allocation adaptée à votre profil, avec une transparence complète sur les frais et notre rémunération.",
  },
  {
    title: "Suivi dans la durée",
    text: "Arbitrages, point annuel et alertes de marché : votre stratégie évolue avec votre vie et l’actualité financière.",
  },
];

export const team = [
  {
    name: "Quentin Nansot",
    role: "Président · Responsable Investissements",
    bio: "Il analyse l’actualité financière et sélectionne les stratégies adaptées à votre profil. Fort de 10 ans d’expérience, il a dirigé l’équipe Adequity au sein des salles de marché de Société Générale CIB. Diplômé de l’EDHEC.",
    phone: "06 74 28 67 73",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/2e46db78-6dc7-4c51-9eff-8b2215443d6a.jpg",
  },
  {
    name: "Charlotte Roblin",
    role: "Associée · Responsable Ingénierie patrimoniale",
    bio: "Elle réalise l’audit de votre situation patrimoniale et coordonne les expertises avec nos partenaires : experts-comptables, notaires, avocats. Auparavant 2 ans en banque privée chez JP Morgan à Paris. Diplômée de l’EDHEC.",
    phone: "06 75 10 13 19",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/61848fe1-33bd-45e0-aebe-e08c98063075.jpg",
  },
];

export const footerColumns = [
  {
    title: "Placements",
    links: ["Assurance-vie", "PER", "SCPI", "Private equity", "Produits structurés"],
  },
  {
    title: "Cabinet",
    links: ["Nos engagements", "Notre équipe", "Méthode", "Actualités"],
  },
  {
    title: "Espace client",
    links: ["Se connecter", "Créer un compte", "Prendre rendez-vous", "Aide"],
  },
];

export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/a5b94398-0b0f-47a5-ba8c-03a750053eda.jpg",
  meeting:
    "https://cdn.magicpatterns.com/patterns/generated-images/ebb2c50c-b5a5-4555-a732-f7bf0a537546.jpg",
};
